import { NumericTextBox, NumericTextBoxChangeEvent } from "@progress/kendo-react-inputs";
import { GridCellProps } from "@progress/kendo-react-grid";
import { CustomGridCellProps } from "../CustomGridCellProps";
import { ReadOnlyProps } from "../../../../Project/EditProject/ReadOnlyProps";

export function NumericTextBoxCell({
  dataItem,
  field,
  onChange,
  editable,
  isReadOnly,
}: GridCellProps & CustomGridCellProps & ReadOnlyProps) {
  const handleChange = (e: NumericTextBoxChangeEvent) => {
    if (onChange) {
      onChange({
        dataIndex: 0,
        dataItem,
        field,
        syntheticEvent: e.syntheticEvent,
        value: e.value,
      });
    }
  };

  const myField = field || "";
  const dataValue = dataItem[myField] ?? null;

  return (
    <td>
      {editable && dataItem.inEdit && !isReadOnly ? (
        <NumericTextBox
          format="#"
          step={1}
          min={0}
          label=""
          onChange={handleChange}
          value={dataValue}
        />
      ) : (
        dataValue
      )}
    </td>
  );
}
